import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  collegeList: [],
}

export const getters = {}

export const mutations = {
  CACHE_COLLEGE_LIST(state, newList) {
    state.collegeList = newList
  },
}

export const actions = {
  // College List Service
  fetchCollegeList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/college/?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_COLLEGE_LIST', list)
        return list
      })
  },

  // Add College Service
  addCollegeData({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/college`, Data)
      .then((response) => {
        const resp = response.data
        return resp
      })
  },

  // Update College Service
  updateCollegeData({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/college/${Data.id}`, Data)
      .then((response) => {
        const resp = response.data
        return resp
      })
  },
  // Delete college
  deleteCollegeData({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/college/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
